import { Link, useParams } from "wouter";
import { SimpleHeader, SimpleFooter, AnimatedBlock } from "@/components/simple-page-chrome";
import { BLOG_POSTS } from "@/content/blog";
import { BLOG_POST_COMPONENTS } from "./registry";
import NotFound from "@/pages/not-found";

function formatDate(iso: string): string {
  const [year, month, day] = iso.split("-").map(Number);
  const date = new Date(Date.UTC(year, month - 1, day));
  return date.toLocaleDateString("es-MX", { day: "numeric", month: "long", year: "numeric", timeZone: "UTC" });
}

export function BlogIndexPage() {
  const posts = [...BLOG_POSTS].sort((a, b) => (a.publishedAt < b.publishedAt ? 1 : -1));

  return (
    <div className="min-h-screen bg-background">
      <SimpleHeader />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
        <AnimatedBlock>
          <p className="text-sm font-medium text-primary tracking-wider uppercase mb-3">Blog</p>
          <h1 className="font-serif text-3xl sm:text-4xl font-bold text-foreground mb-4">
            Artículos sobre cumplimiento NOM-035
          </h1>
          <p className="text-muted-foreground mb-12 max-w-2xl">
            Guías y análisis sobre la NOM-035-STPS, escritos para empresas que necesitan cumplir en serio, no solo llenar un formulario.
          </p>
        </AnimatedBlock>

        <div className="divide-y divide-border">
          {posts.map((post, i) => (
            <AnimatedBlock key={post.slug} delay={Math.min(i * 0.05, 0.3)}>
              <article className="py-6">
                <Link
                  href={`/blog/${post.slug}`}
                  className="font-serif text-xl font-semibold text-foreground hover:text-primary transition-colors"
                  data-testid={`link-blog-${post.slug}`}
                >
                  {post.title}
                </Link>
                <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{post.excerpt}</p>
                <p className="mt-2 text-xs text-muted-foreground/80">
                  {post.author.name} · <time dateTime={post.publishedAt}>{formatDate(post.publishedAt)}</time>
                </p>
              </article>
            </AnimatedBlock>
          ))}
        </div>
      </main>
      <SimpleFooter />
    </div>
  );
}

export function BlogPostPage() {
  const { slug } = useParams<{ slug: string }>();
  const PostComponent = slug ? BLOG_POST_COMPONENTS[slug] : undefined;

  if (!PostComponent) {
    return <NotFound />;
  }

  return <PostComponent />;
}
